import {EFilterForm, Filter} from '@shared/models/filter.model';
import {Utilities as U} from '@shared/utilities/utilities.model';
import { DossierAndWorkingStates } from './enums.model';

export class OperationsFilterModel extends Filter {
	priority: string;
	status: string;
	driver: string;
	driver_first_name: string;
	driver_last_name: string;
	model: string;
	plate: string;
	customer_trading_name: string;
	contract_expiration_date: string;
	last_revision_date: string;
	warranty_active: boolean;
	parts_type: string;
	replacement_vehicle: string;
	additional_services: string;
	kw: string;
	total: string;
	working_type: string;
	working_status: string;
	chassis: string;
	brand: string;
	customer_id: string;
	contract_id: string;
	dashboard_status: string;
	working_number_prefix: string;
	practice_id: string;
	po: string;
	dossier_number_prefix: string;
	user_group: string;
	user_name: string;
	flow_types: string;
	is_wreck: boolean;
	is_onerous: boolean;
	dossier_statuses: string;
	working_statuses: string[];
	commodity_center_id: string;

	with_acceptance		: boolean;
	with_appointment	: boolean;
	exclude_status	  : DossierAndWorkingStates;
	created_at_from		: Date;
	created_at_to			: Date;
	cod_axus					: string;
	ald_commodity_id	: number;
	idd_supplier_code	: string;
	statuses					: string;
	company     			: string;
	causal						: string;
	// flow_type					: DossierFlowType;
	
	// performance e archiviazione
	// serve solo per la ricerca degli interventi attivi
	to_archive	  		: boolean;

	constructor(model?: any) {
		super();
		if (!U.isVoid(model)) {

			this[EFilterForm.order_by]	= U.nullish(model[EFilterForm.order_by], null);

			// dev'essere preso in considerazione il valore false
			this[EFilterForm.asc]	      = !U.isVoid(model[EFilterForm.asc]) ? model[EFilterForm.asc] : null;
			
			this[EFilterForm.page_size]	= U.nullish(model[EFilterForm.page_size], null);
			this[EFilterForm.page]	    = U.nullish(model[EFilterForm.page], null);
			
			this.priority = model.priority;
			this.status = model.status;
			this.driver_first_name = model.driver_first_name;
			this.driver_last_name = model.driver_last_name;
			this.model = model.model;
			this.customer_trading_name = model.customer_trading_name;
			this.plate = model.plate;
			this.contract_expiration_date = model.contract_expiration_date;
			this.last_revision_date = model.last_revision_date;
			this.warranty_active = model.warranty_active;
			this.parts_type = model.parts_type;
			this.replacement_vehicle = model.replacement_vehicle;
			this.additional_services = model.additional_services;
			this.kw = model.kw;
			this.total = model.total;
			this.working_type = model.working_type;
			this.working_status = model.working_status;
			this.chassis = model.chassis;
			this.brand = model.brand;
			this.customer_id = model.customer_id;
			this.contract_id = model.contract_id;
			this.dashboard_status = model.dashboard_status;
			this.working_number_prefix = model.working_number_prefix;
			this.practice_id = model.practice_id;
			this.po = model.po;
			this.dossier_number_prefix = model.dossier_number_prefix;
			this.user_group = model.user_group;
			this.user_name = model.user_name;
			this.flow_types = model.flow_types;
			this.is_wreck = model.is_wreck;
			this.is_onerous = model.is_onerous;
			this.dossier_statuses = model.dossier_statuses;
			this.working_statuses = model.working_statuses;
			this.commodity_center_id = model.commodity_center_id;
			
			this.with_acceptance = model.with_acceptance;
			this.with_appointment = model.with_appointment;
			this.exclude_status = model.exclude_status;
			this.created_at_from = model.created_at_from;
			this.created_at_to = model.created_at_to;
			this.cod_axus = model.cod_axus;
			this.ald_commodity_id = model.ald_commodity_id;
			this.idd_supplier_code = model.idd_supplier_code;
			this.to_archive = model.to_archive;
		}
	}

	clone(): OperationsFilterModel {
		const clone: OperationsFilterModel = new OperationsFilterModel();
		
		clone[EFilterForm.order_by]	 = U.nullish(this[EFilterForm.order_by], null);
		
		// dev'essere preso in considerazione il valore false
		clone[EFilterForm.asc]	     = !U.isVoid(this[EFilterForm.asc]) ? this[EFilterForm.asc] : null;

		clone[EFilterForm.page_size] = U.nullish(this[EFilterForm.page_size], null);
		clone[EFilterForm.page]	   	 = U.nullish(this[EFilterForm.page], null);
		
		clone.priority = this.priority;
		clone.status = this.status;
		clone.driver = this.driver;
		clone.driver_first_name = this.driver_first_name;
		clone.driver_last_name = this.driver_last_name;
		clone.model = this.model;
		clone.plate = !U.isVoid(this.plate) ? this.plate.trim() : this.plate;
		clone.contract_expiration_date = this.contract_expiration_date;
		clone.last_revision_date = this.last_revision_date;
		clone.warranty_active = this.warranty_active;
		clone.parts_type = this.parts_type;
		clone.replacement_vehicle = this.replacement_vehicle;
		clone.additional_services = this.additional_services;
		clone.kw = this.kw;
		clone.total = this.total;
		clone.customer_trading_name = this.customer_trading_name;
		clone.working_type = this.working_type;
		clone.working_status = this.working_status;
		clone.chassis = this.chassis;
		clone.brand = this.brand;
		clone.customer_id = this.customer_id;
		clone.contract_id = this.contract_id;

		clone.page = this.page;
		clone.page_size = this.page_size;
		clone.order_by = this.order_by;
		clone.asc = this.asc;
		clone.dashboard_status = this.dashboard_status;
		clone.working_number_prefix = this.working_number_prefix;
		clone.practice_id = this.practice_id;
		clone.po = this.po;
		clone.dossier_number_prefix = this.dossier_number_prefix;
		clone.user_group = this.user_group;
		clone.user_name = this.user_name;
		clone.flow_types = this.flow_types;
		clone.is_wreck = this.is_wreck;
		clone.is_onerous = this.is_onerous;
		clone.dossier_statuses = this.dossier_statuses;
		clone.working_statuses = this.working_statuses;
		clone.commodity_center_id = this.commodity_center_id;

		clone.with_acceptance = this.with_acceptance;
		clone.with_appointment = this.with_appointment;
		clone.exclude_status = this.exclude_status;
		clone.created_at_from = this.created_at_from;
		clone.created_at_to = this.created_at_to;
		clone.cod_axus = this.cod_axus;
		clone.ald_commodity_id = this.ald_commodity_id;
		clone.idd_supplier_code = this.idd_supplier_code;
		clone.to_archive = this.to_archive;
		return clone;
	}

	getFilterUrl(): string {
		return U.getQuery(this);
	}

	newFilter(model?: any): OperationsFilterModel {
		return new OperationsFilterModel(model);
	}
}
